module.exports = {
    SUCCESS: "SUCCESS",

    TRACK_CLICKOUT: 'clickout',
    TRACK_PRODUCTLIKE: 'ProductLiked',
    TRACK_FILTER_CLICKED_EVENT: 'filterClickedEvent',
    TRACK_SIMILAR_BRANDS_CLICKED_EVENT: "similarBrandsClickedEvent",
    TRACK_FILTER_SUGGESTIONS: 'filterSuggestionsEvent',
    TRACK_GA_EVENT: 'gaEvent',
    TRACK_GA_PAGEVIEW: 'gaPageview',
    TRACK_QUICK_VIEW_OPEN_EVENT: "quickviewOpenEvent",

    REDIRECT_URL: '/redirect.action',
    REDIRECT_TRACKING_URL: '/redirectTracking.action',

    // VALIDATION
    VALIDATION_EMAIL_AVAILABLE: "emailavailability",
    VALIDATION_EMAIL_AVAILABLE_URL: "/api/emailIsAvailable",
    VALIDATION_ALIAS: "alias",
    VALIDATION_ALIAS_AVAILABLE: "aliasavailability",
    VALIDATION_URL_VALID: "validurl",
    VALIDATION_ALIAS_AVAILABLE_URL: "/api/usernameIsAvailable",
    VALIDATION_ALIAS_MAX: 20,
    VALIDATION_ALIAS_MIN: 3,
    VALIDATION_PASSWORD_MIN: 6,
    VALIDATION_GENDER_MIN: 2,

    SIGNOUT_FIREBASE: '/User/Firebase-Logout/',
    COOKIE_IS_REGISTERED: 'st_reg',

    LOCAL_WISHLIST: "stylight-local-wishlist",

    EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    NEWSLETTER_SIGNUP_URL: '/api/newsletterSignup',
    NEWSLETTER_UNSUBSCRIBE_URL: '/api/newsletterUnsubscribe'
};
